<template lang="pug">
.room-wrapper
  //- small {{ room }} {{ $dayjs.utc(room.start_time + "+0800") }}
  .room-container(:class="getBackgroundCss(room)")
    //- .free-room(v-if="room.room_type == 3")
    //-   span.free-room-text {{ $t('m.ROOM_T3') }}
    .tournament-free-room-shadow(v-if="room.room_type == 3")
      .tournament-free-room
        .free-room-text {{ $t('ui.play_to_earn') }}
    .d-flex.justify-content-between.align-items-center
      div
        div
          | {{ $t('ui.pool') }}:
          span.amount.ml-1 {{ $numeral(room.points).format("0,0") }}
          span.tournament-jackpot.ml-2(v-if="room.jackpot > 0")
            i.fad.fa-chevron-double-up
            span {{ room.jackpot * 100 }}%
        div {{ $t('ui.room') }}: {{ room.room_id }}
      .d-flex
        .tournament-countdown(v-if="(new Date(room.start_time)) > (new Date())")
          small.mr-2 {{ $t("ui.last_join_time") }}
          span(:data-tick="ticker") {{ getCountDown(room.start_time) }}
        .private-room(v-if="room.room_type == 2")
          i.fa.fa-lock.mr-1
          | {{ $t('ui.private') }}
        template(v-else)
          .private-room.exclusive(v-if="room.system_id.toUpperCase() != 'MERCEDES'")
            i.fad.fa-crown.mr-2
            span {{ $t('ui.exclusive') }}
        .public-room.mr-1(v-if="room.room_type != 2 && room.room_host === 1")
          i.fa.fa-home
          | {{ $t('ui.owner') }}
        .status(:class="'room_' + room.room_status") {{ $t('m.ROOM_' + room.room_status) }}
    a(@click="enterRoom(room)")
      .join-now-wrapper(v-if="room.room_status === 0 && room.room_join === 0 && room.room_count < room.room_limit")
        .player
          i.fad.fa-users
          span.mx-1 {{ $t('ui.players') }}:
          span {{ room.room_count }} / {{ room.room_limit }}
        div(v-if="room.room_rate > 0")
          | {{ $t('ui.entry_fee') }}:
          span.amount.mr-1.ml-1 {{ room.room_rate }}
          small(style="color: #08ff00cc;") ( {{ currencyCode }} {{ $numeral(room.room_rate / room.rate).format("0,0.00")  }} )
        div(v-else)
          | {{ $t('ui.free_room') }}
      .join-now-wrapper(v-else)
        .player(v-if="room.room_count < room.room_limit")
          i.fad.fa-users
          span.mx-1 {{ $t('ui.players') }}:
          span {{ room.room_count }} / {{ room.room_limit }}
        .player(v-else) {{ $t('message.room_full') }}
        div(v-if="(room.room_join > 0)")
          span.tournament-fc-light(v-if="room.room_host === 1") {{ $t('message.my_room') }}
          span.tournament-fc-light(v-else) {{ $t('message.room_joined') }}
        .trophy(v-if="room.room_status == 3 && (room.position != null) && ([1,2,3].includes(room.position))")
          img.img-fluid(:src="'/images/tournament/trophy' + room.position.toString() + '.svg'")
  template(v-if="(room.total_match != null) && (room.total_match > 0)")
    .room-match-wrapper.collapse(:id="'room-' + room.room_id")
      template(v-if="leagueList.hasOwnProperty(room.room_id)")
        .room-league-wrapper(v-for="ln in leagueList[room.room_id]")
          .select-league-box.room-league.collapsed(
            @click="populateMatchList(room.room_id, ln.league_id)"
            data-toggle="collapse"
            :data-target="'#room-' + room.room_id + '-league-' + ln.league_id"
            aria-expanded='false'
            :aria-controls="'room-' + room.room_id + '-league-' + ln.league_id"
          )
            .tournament-league-club
              img(v-if="ln.logo" :src="getLogo('league', ln.logo)")
            .tournament-text.flex-fill
              | {{ getName('name_', ln) }}
            .tournament-arrow
              i.fad.ml-2.fa-chevron-up
          .room-matches.collapse(:id="'room-' + room.room_id + '-league-' + ln.league_id")
            template(v-if="matchList.hasOwnProperty(room.room_id)")
              template(v-if="matchList[room.room_id].hasOwnProperty(ln.league_id)")
                .room-match.d-flex(v-for="match in matchList[room.room_id][ln.league_id]")
                  .date(v-if="match.match_time") {{ getMatchDate(match.match_time) }}
                    span.time {{ getMatchTime(match.match_time) }}
                  .date(v-else) --:--
                  .team
                    | {{ getName('home_name_', match) }}
                    span.home-vs-away -vs-
                    | {{ getName('away_name_', match) }}
    .match-wrapper.collapsed(
      v-if="(room.total_match != null) && (room.total_match > 0)"
      @click="getLeagueList(room.room_id, room)"
      data-toggle='collapse'
      :data-target="'#room-' + room.room_id"
      aria-expanded='false'
      :aria-controls="'room-' + room.room_id"
    ) {{ room.match_count ? room.match_count + " / " + room.total_match : room.total_match }} {{ $t('ui.matches') }}
</template>


<script>
import config from "@/config";
import errors from "@/errors";
import { EventBus } from "@/library/_event-bus.js";
import service from "@/views/tournament/library/_xhr.js";

export default {
  props: {
    room: {
      type: Object
    }
  },
  data() {
    return {
      ticker: 0,
      leagueList: {},
      matchList: {},
      loading: {
        getLeagueList: false,
        getMatchList: false,
        getMemberBetList: false,
      }
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace('UST', 'USDT');
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    getMatchDate(e) {
      return this.$dayjs(e).subtract(config.getCurrencyMinuteOffset(this.currencyCode), "minute").format("MM/DD");
    },
    getMatchTime(e) {
      return this.$dayjs(e).subtract(config.getCurrencyMinuteOffset(this.currencyCode), "minute").format("hh:mm A");
    },
    getCountDown(e) {
      var time = this.$dayjs(e).subtract(15, 'minute').format("YYYY-MM-DDTHH:mm:ss")
      var difference = this.$dayjs.utc(time + "+0800").diff(this.$dayjs.utc());
      var days = Math.floor(difference / (1000 * 60 * 60 * 24));
      var hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((difference / 1000 / 60) % 60);
      var seconds = Math.floor((difference / 1000) % 60);
      if (days < 0 || hours < 0 || minutes < 0 || seconds < 0) {
        return this.$t("ui.match_started");
      } else {
        if (days === 0) {
          if (hours === 0) {
            if (minutes === 0) {
              return seconds + "s";
            } else {
              return minutes + "m";
            }
          } else {
            return hours + "h " + minutes + "m";
          }
        } else {
          return days + "d " + hours + "h " + minutes + "m";
        }
      }
    },
    getBackgroundCss(room){
      let logo = room.league_logo
      let type = room.room_type
      let bg = ''

      if(logo && type != 2) {
        return logo.split('.')[0]
      } else {
        return bg
      }
    },
    refreshRoom(e) {
      EventBus.$emit("roomEnterById", e);
    },
    // leaveRoom() {
    //   this.$emit("room-leave");
    // },
    enterRoom(room) {
      this.$emit("room-enter", room);
    },
    // joinRoom(room) {
    //   this.$emit("room-join", room);
    // },
    populateMatchList(e, f) {
      this.getMatchList(e, f).then((res) => {});
    },
    getMatchList(e, f) {
      return new Promise((resolve, reject) => {
        if ($("#room-" + e + "-league-" + f).hasClass("show") === true) {
          return;
        }

        var json = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          room_id: e,
          league_id: f,
          page_number: 1,
          page_size: 100,
        };

        var feedback = {
          success: false,
          status: errors.session.invalidSession,
        };

        this.loading.getMatchList = true;
        service.getMatchList(config.tournamentUrl().roommatchlist, json).then(
          (result) => {
            this.loading.getMatchList = false;
            if (result) {
              feedback.success = result.success;
              feedback.status = result.status;
              if (result.success == true) {
                if (!this.matchList.hasOwnProperty(e)) {
                  this.$set(this.matchList, e, {});
                }
                this.$set(this.matchList[e], f, result.data.value);
                resolve({ league_id: f, count: result.data.value.length });
              } else {
                this.$helpers.handleFeedback(feedback.status);
                resolve({ league_id: f, count: 0 });
              }
            } else {
              resolve({ league_id: f, count: 0 });
            }
          },
          (err) => {
            console.log(err);
            this.loading.getMatchList = false;
            feedback.success = false;
            feedback.status = errors.request.failed;
            this.$helpers.handleFeedback(err.status);
            resolve({ league_id: f, count: 0 });
          }
        );
      });
    },
    getLeagueList(e, rn) {
      if ($("#room-" + e).hasClass("show") === true) {
        return;
      }

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        room_id: e,
        page_number: 1,
        page_size: 100,
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession,
      };

      this.loading.getLeagueList = true;
      service.getLeagueList(config.tournamentUrl().roomleaguelist, json).then(
        (result) => {
          this.loading.getLeagueList = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              var ln = result.data.value;
              var j = 0;
              var k = ln.length;
              var items = [];
              for (var i = 0; i < k; i++) {
                var lid = ln[i].league_id;
                var ret = false;
                this.getMatchList(e, lid).then((res) => {
                  items.push(res);
                  j = j + 1;
                  if (j == k) {
                    setTimeout(() => {
                      var deleted = [];
                      var inserted_array = [];
                      // var inserted_object = {};
                      // var inserted_ids = [];

                      var mc = 0;
                      for (var i = 0; i < items.length; i++) {
                        mc += items[i].count;
                        if (items[i].count <= 0) {
                          deleted.push(items[i].league_id);
                        }
                      }
                      // this.match_count = mc;
                      if (rn) rn["match_count"] = mc;
                      for (var i = 0; i < k; i++) {
                        if (!deleted.includes(ln[i].league_id)) {
                          // inserted_ids.push(ln[i].league_id);
                          inserted_array.push(ln[i]);
                          // inserted_object[ln[i].league_id] = ln[i];
                        }
                      }
                      this.$set(this.leagueList, e, inserted_array);
                    }, 200);
                  }
                });
              }
              // this.$set(this.leagueList, e, result.data.value);
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        (err) => {
          console.log(err);
          this.loading.getLeagueList = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getName(p, e) {
      var name = e[p + this.language];
      if (name == null || name == "" || !name) {
        name = e[p + "en"];
      }
      return name;
    },
    getLogo(p, e) {
      return config.flagPath + p + "/" + e;
    },
    getBackground(e) {
      return config.tournamentBackgroundPath + e;
    },
    getMemberBetList(room) {
      if (![0, 1].includes(room.room_status)) {
        return;
      }

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        room_id: room.room_id,
        page_number: 1,
        page_size: 1000,
        target: "all",
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession,
      };

      this.betList = [];
      this.loading.getMemberBetList = true;
      service.memberBetList(config.tournamentUrl().memberbetlist, json).then(
        (result) => {
          this.loading.getMemberBetList = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              this.betList = result.data.value;
              EventBus.$emit("ROOM_BETLIST", {
                room_id: room.room_id,
                data: this.betList,
              });
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        (err) => {
          console.log(err);
          this.loading.getMemberBetList = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
  }
}
</script>